import "../styling/App.css";
import React, { useEffect, useState } from "react";
import LeftMenu from "./LeftMenu";
import Content from "./Content";
import Header from "./header";
// NOTE: useSelector, useDispatch, and useNavigate are removed as they are not needed here.
import RightSidebar from "./RightSidebar";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Views = ({
  handleMenuItemClick,
  selectedMenuItem,
  setSelectedMenuItem,
  handleDropdownClick, 
  onEventClick,
  rightPaneEventClick,
  onPanelEventClick,
  handleViewAllClick,
  // This prop comes from App.js now
  handleLogout, 
}) => {
  const [clientRecord, setClientRecord] = useState(null);
  const [initialBusinessEventTab, setInitialBusinessEventTab] = useState(0);

  // REMOVED both useEffect hooks that were handling navigation.
  // App.js is already protecting this route.
  // RIGHT SIDEBAR SLOT (owned by Views)
  const [rightSidebar, setRightSidebar] = useState(null);
  const hasSidebar = Boolean(rightSidebar);

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const navigate = useNavigate();

  // Mobile left-drawer
  const [isLeftOpen, setIsLeftOpen] = useState(false);
  const toggleLeftMenu = () => setIsLeftOpen((s) => !s);
  const closeLeftMenu = () => setIsLeftOpen(false);

  useEffect(() => {
    // Reset clientRecord when menu changes - This is good logic to keep.
    setClientRecord(null);
  }, [selectedMenuItem]);

  // Auth guard
  useEffect(() => {
    if (!isLoggedIn) navigate("/login");
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    setIsLeftOpen(false);
  }, [selectedMenuItem]);

  const onClientClick = (record) => {
    setClientRecord(record);
  };

  return (
    <div className="appContain">
      <Header
        onClickAccountInfo={handleDropdownClick}
        selectedMenuItem={selectedMenuItem}
        setSelectedMenuItem={setSelectedMenuItem}
        onEventClick={onEventClick}
        handleClientClick={onClientClick}
        setInitialBusinessEventTab={setInitialBusinessEventTab}
        onToggleLeftMenu={toggleLeftMenu}
        isLeftMenuOpen={isLeftOpen}
        // Pass the logout handler to the header where the logout button likely is
        handleLogout={handleLogout}
      />

      <div className={`app ${hasSidebar ? "app--with-right-sidebar" : ""}`} style={{ marginTop: "70px" }}>
        <LeftMenu
          selectedMenuItem={selectedMenuItem}
          onMenuItemClick={handleMenuItemClick}
          isMobileOpen={isLeftOpen}
          onRequestClose={closeLeftMenu}
          onEventClick={onEventClick}
          clientRecord={clientRecord}
        />
        <Content
          selectedMenuItem={selectedMenuItem}
          setSelectedMenuItem={setSelectedMenuItem}
          handleClientClick={onClientClick}
          onEventClick={onEventClick}
          handleViewAllClick={handleViewAllClick}
          rightPaneEventClick={rightPaneEventClick}
          onPanelEventClick={onPanelEventClick}
          onClickAccountInfoButton={handleDropdownClick}
          clientRecord={clientRecord}
          initialBusinessEventTab={initialBusinessEventTab}
          setInitialBusinessEventTab={setInitialBusinessEventTab}
          setRightSidebar={setRightSidebar}
        />
        {hasSidebar && <RightSidebar>{rightSidebar}</RightSidebar>}
      </div>
      <div
        className={`backdrop ${isLeftOpen ? "backdrop--shown" : ""}`}
        onClick={closeLeftMenu}
      />
    </div>
  );
};

export default Views;